const USE_CASES = [
    {
        title: "Hearing conversations clearly",
        body: "From morning chai with family to one-on-ones at the office — Styletto IX brings voices into focus without distortion.",
        image: "https://cdn.signia.net/-/media/signia/global/images/campaigns/signia-ix/styletto-ix/styletto-ix_group-conversation_modified_1920x1080_replacement.jpg",
    },
    {
        title: "Watching TV comfortably",
        body: "Stream TV audio directly to your hearing aids over Bluetooth — your volume, no disturbance to family.",
        image: "https://cdn.signia.net/-/media/signia/global/images/products/signia-ix/styletto-ix/styletto-ix_black_graphite_double_1000x1000_c9212a90-e9f1-4a_5d8928e7.jpg",
    },
    {
        title: "Phone calls & streaming",
        body: "Calls go straight to your ears — both iPhone and Android — with crystal-clear handsfree clarity.",
        image: "https://cdn.signia.net/-/media/signia/global/images/products/signia-ix/styletto-ix/styletto-ix_black_silver_double_1000x1000_66ba76a8-7c33-4533_91626ecd.jpg",
    },
    {
        title: "Restaurants & noisy places",
        body: "Integrated Xperience separates the speaker in front of you from the noise behind — so dinners stay enjoyable.",
        image: "https://cdn.signia.net/-/media/signia/global/images/campaigns/signia-ix/silk-chargego-ix/silk-ix_bouldering_man-holding-hearing-aids_bg_1920x1080.jpg",
    },
];

export default function UseCases() {
    return (
        <section className="section" data-testid="use-cases">
            <div className="container-x">
                <div className="max-w-[680px]">
                    <p className="eyebrow">Real-life moments</p>
                    <h2 className="font-serif text-[40px] md:text-[56px] leading-[1.04] mt-3">
                        Built for the way <span className="italic text-[#003E4D]">you actually live.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mt-14">
                    {USE_CASES.map((u, i) => (
                        <article key={i} className="group" data-testid={`use-case-${i}`}>
                            <div className="aspect-[4/3] rounded-3xl overflow-hidden bg-[#f3f4f6]">
                                <img
                                    src={u.image}
                                    alt={u.title}
                                    className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-700"
                                    loading="lazy"
                                />
                            </div>
                            <h3 className="font-serif text-[26px] md:text-[30px] mt-6 text-[#1a1a1a]">{u.title}</h3>
                            <p className="text-[15px] text-[#4a5568] mt-3 leading-relaxed max-w-[520px]">{u.body}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
